import { NotificationExtension } from "../extension/NotificationExtension";

/**
 * Tải file qua fetch + hiển thị loading toast (spinner) trong lúc tải,
 * cập nhật thành công/thất bại khi xong. Dùng chung cho các nút "Tải xuống".
 */
export async function downloadFileWithLoading(
  url: string,
  filename: string,
  contentType: string = "application/zip",
  loadingMessage: string = "Đang tải file..."
): Promise<void> {
  const noti = NotificationExtension.Loading(loadingMessage);
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": contentType },
    });
    if (!response.ok) throw new Error("Failed to download file");

    const blob = await response.blob();
    const objUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objUrl);

    noti.success("Đã tải file");
  } catch (error) {
    noti.fail("Tải file thất bại");
  }
}
